// extracted by mini-css-extract-plugin
module.exports = {"base":"Spinner_base__0neWm","spin":"Spinner_spin__OzyPg","circle":"Spinner_circle__kL_FF","arc":"Spinner_arc__kY89p"};